module.exports = __webpack_public_path__ + "static/lips-before-ad4f595f22e9b6a8f0f6b6636776d332.jpg";